import { createElementBlock as r, openBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function d(t, l) {
  return o(), r("svg", n, [...l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 5.886c.402 0 .729.326.729.728v7.772a.729.729 0 1 1-1.458 0V6.614c0-.402.327-.728.729-.728",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.886 10.5c0-.402.326-.729.728-.729h7.772a.729.729 0 0 1 0 1.458H6.614a.73.73 0 0 1-.728-.729",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.49 4.49a8.5 8.5 0 1 1 12.02 12.02A8.5 8.5 0 0 1 4.49 4.49m6.01-1.033a7.043 7.043 0 1 0 0 14.086 7.043 7.043 0 0 0 0-14.086",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
